import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { HierarchyService } from '../services/hierarchy.service';
import { PageHeader } from 'src/app/models/common/page-header';

@Component({
  selector: '',
  template: '',
})
export class MyTeamDetailsTreeHandler extends BaseSearchComponent<HierarchyService> implements OnInit {
  @Input() agents: any[] = [];
  @Input() level = 0;
  constructor(
    public service: HierarchyService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public route: ActivatedRoute
  ) {
    super(service, router, headerService);
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    header.title = this.settingService.getLabelValue('uplineHierarchy');
    return header;
  }
}
